import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import { ImFacebook2, ImTwitter, ImLinkedin } from 'react-icons/im';

import Logo from '../../assets/logo_inverse.png';
import LanguageSelector from 'components/LanguageSelector/LanguageSelector';
import LanguageContext from 'context/LanguageContext';

function Navbar() {
  const { language } = useContext(LanguageContext);
  // NavLinks Italiano
  const navLinks = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: 'Company',
      link: '/company',
    },
    {
      name: 'Team',
      link: '/team',
    },
    {
      name: 'Prodotti',
      link: '/prodotti',
    },
    {
      name: 'Servizi',
      link: '/servizi',
    },
    {
      name: 'Progetti',
      link: '/progetti',
    },
    {
      name: 'Carriera',
      link: '/carriera',
    },
  ];
  // NavLinks Inglese
  const navLinksEn = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: 'Company',
      link: '/company',
    },
    {
      name: 'Team',
      link: '/team',
    },
    {
      name: 'Products',
      link: '/products',
    },
    {
      name: 'Services',
      link: '/services',
    },
    {
      name: 'Projects',
      link: '/projects',
    },
    {
      name: 'Careers',
      link: '/careers',
    },
  ];
  //Social
  const social = [
    {
      icon: <ImFacebook2 className="w-6 h-6 fill-white" />,
      title: 'Facebook',
      href: 'https://www.facebook.com',
    },
    {
      icon: <ImTwitter className="w-6 h-6 fill-white" />,
      title: 'Twitter',
      href: 'https://twitter.com',
    },
    {
      icon: <ImLinkedin className="w-6 h-6 fill-white" />,
      title: 'LinkedIn',
      href: 'https://www.linkedin.com',
    },
  ];

  // Gestione del menu mobile
  const [open, setOpen] = useState(false);

  const handleMenu = () => {
    setOpen(true);
  };

  const handleNav = () => {
    setOpen(false);
  };

  return (
    <header>
      <div
        className={`bg-black h-full w-[100%] z-10 fixed text-white container px-10 pt-5 transition-all ease-in-out duration-300 ${
          open ? 'top-0 left-0' : '-left-full'
        }`}
      >
        <div className="flex items-center justify-between">
          <Link to="/" onClick={handleNav}>
            <img src={Logo} alt="" className="w-20" />
          </Link>
          <button onClick={handleNav}>
            <AiOutlineClose className="w-6 h-6 fill-white" />
          </button>
        </div>

        <div className="mt-14">
          <ul className="flex flex-col items-start justify-start gap-6 text-2xl">
            {language === 'it'
              ? navLinks.map((navLink, id) => (
                  <Link onClick={handleNav} to={navLink.link}>
                    <li key={id}>{navLink.name}</li>
                  </Link>
                ))
              : navLinksEn.map((navLink, id) => (
                  <Link onClick={handleNav} to={navLink.link}>
                    <li key={id}>{navLink.name}</li>
                  </Link>
                ))}
            <Link
              onClick={handleNav}
              to={language === 'it' ? '/contatti' : '/contact-us'}
            >
              {language === 'it' ? 'Contattaci' : 'Contact Us'}
            </Link>
          </ul>
        </div>
        <ul className="flex gap-4 mt-10">
          {social.map((social, id) => (
            <a href={social.href} target="_blank" rel="noreferrer">
              <li key={id}>{social.icon}</li>
            </a>
          ))}
        </ul>
        <div className="mt-10">
          <span className="text-xl font-bold">eDriveLab srl</span>
          <br />
          Via Giuseppe di Vittorio, 60
          <br />
          43044 - Lemignano di Collecchio (PR)
          <br />
          <a href="mailto:info@edrivelab.it">info@edrivelab.it</a>
        </div>
      </div>

      {/* Desktop */}
      <nav className="relative w-full h-20 text-white bg-gray-800 shadow-lg">
        <div className="container flex flex-row-reverse items-center justify-between h-full px-10 mx-auto md:flex-row">
          <div className="md:hidden">
            <LanguageSelector />
          </div>

          <Link to="/">
            <img src={Logo} alt="" className="w-20" />
          </Link>
          <div className="items-center hidden gap-6 md:flex">
            <ul className="flex items-center gap-6">
              {language === 'it'
                ? navLinks.map((navLink, id) => (
                    <Link onClick={handleNav} to={navLink.link}>
                      <li key={id}>{navLink.name}</li>
                    </Link>
                  ))
                : navLinksEn.map((navLink, id) => (
                    <Link onClick={handleNav} to={navLink.link}>
                      <li key={id}>{navLink.name}</li>
                    </Link>
                  ))}
            </ul>
            <Link
              onClick={handleNav}
              to={language === 'it' ? '/contatti' : '/contact-us'}
            >
              <button className="px-5 py-1.5 bg-blue-600 text-white rounded-lg transition-all hover:bg-blue-700">
                {language === 'it' ? 'Contattaci' : 'Contact us'}
              </button>
            </Link>
            <LanguageSelector />
          </div>
          <button onClick={handleMenu} className="md:hidden">
            <AiOutlineMenu className="w-6 h-6 fill-white" />
          </button>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
